import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useModal } from 'core/modules/Modal/ModalProvider';
import orgConfig from 'org/configs/org.config';
import { useTriggerSectionIsViewedGaEvent } from 'core/hooks/useTriggerSectionIsViewedGaEvent';
import { triggerEducationalTileIsViewed } from 'core/modules/Instore2/actions';

import config from '../configs';

function AddCardTile({ tileViewClassName }) {
  const { addCardInstoreLabel } = config;
  const dispatch = useDispatch();
  const tileRef = useRef();
  const { earnType } = orgConfig;
  const { openModal } = useModal();
  const openAddCardModal = () => openModal({ name: 'mt_instoreAddNewCard2' });

  const dispatchTriggerSectionIsViewed = () => dispatch(triggerEducationalTileIsViewed(true));
  useTriggerSectionIsViewedGaEvent(tileRef, dispatchTriggerSectionIsViewed);

  return (
    <div
      ref={tileRef}
      className={`mn_instoreEducationalTile mn_addCardTile ${tileViewClassName}`}
      onClick={openAddCardModal}
      tabIndex={0}
      role="button"
    >
      <div className="mn_educationalTileContent">
        <div className="mn_icon" />
        <div className="mn_description">
          <div className="mn_info">
            Add your card to start earning {earnType} <span className="mn_noWrap">{addCardInstoreLabel}</span>
            <span className="mn_dot">.</span>
          </div>
          <div className="mn_cta">Add a card</div>
        </div>
      </div>
    </div>
  );
}

export default AddCardTile;
